<template>
  <BittsDrawer
    :visible="visible"
    :show-footer="false"
    :mask="false"
    title=""
    :width="drawerWidth"
    :stop-teleport="true"
    class="ai-chat-drawer"
    header-margin="0px"
    :wrapper-class="
      resizing ? 'ai-chat-drawer__wrapper' : 'ai-chat-drawer-root'
    "
  >
    <template #content>
      <div class="ai-chat-drawer__content">
        <AIChat
          :visible="visible"
          :window-mode="false"
          @ai-chat-closed="onClose"
        />
      </div>
    </template>
  </BittsDrawer>
</template>
<script setup lang="ts">
import { BittsDrawer } from '@crossbeam/bitts';

import interact from 'interactjs';
import { ref, watch } from 'vue';

import AIChat from '@/components/navbar/AIChat.vue';

const { visible = false } = defineProps<{
  visible?: boolean;
}>();

const emit = defineEmits<(e: 'ai-chat-closed') => void>();

const resizing = ref(false);
const drawerWidth = ref(400);
const closing = ref(false);
function onClose() {
  closing.value = true;
  emit('ai-chat-closed');
  closing.value = false;
}

function setResizable() {
  setTimeout(() => {
    if (visible) {
      const drawerElement: HTMLElement | null = document.querySelector(
        '.ant-drawer-content-wrapper',
      );
      if (drawerElement) {
        interact(drawerElement)
          .resizable({
            edges: { left: true, right: false, bottom: false, top: false },
            inertia: true,
            modifiers: [
              interact.modifiers.restrictSize({
                min: { width: 300, height: 1200 },
                max: { width: 800, height: 1200 },
              }),
            ],
          })
          .on('resizestart', () => {
            resizing.value = true;
          })
          .on('resizemove', (event) => {
            if (closing.value) return;
            drawerWidth.value = event.rect.width;
          })
          .on('resizeend', () => {
            resizing.value = false;
          });
      }
    }
  }, 100);
}
watch(
  () => visible,
  (newVal) => {
    if (newVal) setResizable();
  },
  { immediate: true },
);
</script>

<style lang="pcss">
@reference "../../css/theme.css";
.ai-chat-drawer__content,
.ai-chat-drawer__content .ai-chat {
  @apply h-full rounded-none;
}
.ai-chat-drawer__content .ai-chat {
  @apply h-full flex flex-col;
}
.ai-chat-drawer__content .ai-chat__body {
  @apply h-full flex-1;
}
.ai-chat-drawer__content .ai-chat__footer {
  @apply rounded-none z-30 sticky bottom-0;
}
.ai-chat-drawer-root,
.ai-chat-drawer__wrapper {
  header {
    @apply hidden;
  }
}
.ai-chat-drawer__wrapper {
  .ant-drawer-content-wrapper {
    @apply transition-none;
  }
}
.ai-chat-drawer {
  .ant-drawer-inline {
    @apply fixed;
  }
}
</style>
